import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext from '@sdk/lang/gettext';
import Button from '@sdk/components/ui/buttons/Button';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

type Props = {
  bookCallUrl: string;
  onClose?: VoidFunction;
};
const BookCall: React.FC<React.PropsWithChildren<Props>> = ({ bookCallUrl, onClose }) => {
  const onClick = (): void => {
    const tab = window.open(bookCallUrl, '_blank');
    tab.focus();
    onClose?.();
  };

  return (
    <Column>
      <Text14 themeColor={ThemeColorType.gray} mBottom={16} semiBold>
        {gettext('Thank you for your input!')}
      </Text14>
      <Text14 themeColor={ThemeColorType.gray} mBottom={24}>
        {gettext(
          'We highly value your feedback and use it to keep improving our product. We would love to hear more from you over a call.'
        )}
      </Text14>
      <Text14 themeColor={ThemeColorType.gray} mBottom={30} fontWeight="400">
        {gettext('Please let us know when is convenient.')}
      </Text14>

      <Button buttonType={ButtonType.primary} onClick={onClick}>
        {gettext('Book a call')}
      </Button>
    </Column>
  );
};

export default BookCall;
